"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDictateInterims;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDictateInterims() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var dictateInterims = _ref.dictateInterims;
    return dictateInterims;
  }) || [], (0, _useWebChatAPIContext.default)().setDictateInterims];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VEaWN0YXRlSW50ZXJpbXMudHMiXSwibmFtZXMiOlsidXNlRGljdGF0ZUludGVyaW1zIiwiZGljdGF0ZUludGVyaW1zIiwic2V0RGljdGF0ZUludGVyaW1zIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFZSxTQUFTQSxrQkFBVCxHQUF3RTtBQUNyRixTQUFPLENBQUMsc0NBQVk7QUFBQSxRQUFHQyxlQUFILFFBQUdBLGVBQUg7QUFBQSxXQUF5QkEsZUFBekI7QUFBQSxHQUFaLEtBQXlELEVBQTFELEVBQThELHFDQUF1QkMsa0JBQXJGLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VEaWN0YXRlSW50ZXJpbXMoKTogW3N0cmluZ1tdLCAoaW50ZXJpbXM6IHN0cmluZ1tdKSA9PiB2b2lkXSB7XG4gIHJldHVybiBbdXNlU2VsZWN0b3IoKHsgZGljdGF0ZUludGVyaW1zIH0pID0+IGRpY3RhdGVJbnRlcmltcykgfHwgW10sIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2V0RGljdGF0ZUludGVyaW1zXTtcbn1cbiJdfQ==